/* Inner Affairs theme — Web Grow X */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };
  const root = (T.routes.root || '/').replace(/\/?$/, '/');
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* ignore */ } }
  };
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  function formatMoney(cents) {
    const fmt = T.moneyFormat || 'Rs. {{amount}}';
    const value = (cents / 100);
    const withDelim = (n, dec, th = ',', ds = '.') => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelim(value, 0);
        case 'amount_with_comma_separator': return withDelim(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(value, 0, '.', ',');
        default: return withDelim(value, 2);
      }
    });
  }

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#Toast'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------------- Drawers ---------------- */
  const Drawer = {
    current: null, lastFocus: null,
    open(name) {
      const d = $(`[data-drawer="${name}"]`);
      if (!d) return false;
      if (this.current && this.current !== d) this.close(true);
      this.lastFocus = document.activeElement;
      d.classList.add('is-open');
      $('[data-overlay]')?.classList.add('is-active');
      document.body.classList.add('is-locked');
      this.current = d;
      setTimeout(() => (d.querySelector('[data-drawer-close]') || d).focus({ preventScroll: true }), 50);
      return true;
    },
    close(silent) {
      const d = this.current; if (!d) return;
      d.classList.remove('is-open');
      this.current = null;
      if (!silent) {
        $('[data-overlay]')?.classList.remove('is-active');
        document.body.classList.remove('is-locked');
        this.lastFocus?.focus?.({ preventScroll: true });
      }
    }
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && T.cartType !== 'drawer') return;
      if (Drawer.open(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) { Drawer.close(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { Drawer.close(); closePopup(); $$('.quick-pick[open]').forEach(d => d.removeAttribute('open')); }
    if (e.key === 'Tab' && Drawer.current) {
      const f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not(.visually-hidden), select, textarea, summary', Drawer.current).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Header ---------------- */
  function initHeader() {
    const header = $('[data-header]'); if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    $('[data-search-toggle]', header)?.addEventListener('click', () => {
      header.classList.toggle('search-open');
      if (header.classList.contains('search-open')) $('[data-search-input]', header)?.focus();
    });
    // Predictive search
    $$('[data-predictive-search]').forEach((form) => {
      const input = $('[data-search-input]', form), box = $('[data-predictive-results]', form);
      if (!input || !box || !T.routes.predictiveSearch) return;
      let ctrl;
      const run = debounce(async () => {
        const q = input.value.trim();
        if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
          const html = await fetch(url, { signal: ctrl.signal }).then(r => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.predictive__inner');
          box.innerHTML = inner ? inner.outerHTML : '';
          box.hidden = !inner;
        } catch (err) { /* aborted */ }
      }, 250);
      input.addEventListener('input', run);
      input.addEventListener('focus', () => { if (box.innerHTML) box.hidden = false; });
      document.addEventListener('click', (e) => { if (!form.contains(e.target)) box.hidden = true; });
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  let revealIO;
  function initReveal(scope = document) {
    const els = $$('.reveal:not(.is-visible)', scope);
    if (!document.documentElement.classList.contains('anim-reveal') || !('IntersectionObserver' in window)) { els.forEach(el => el.classList.add('is-visible')); return; }
    revealIO = revealIO || new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); revealIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(el => revealIO.observe(el));
  }

  /* ---------------- Hero slideshow ---------------- */
  function initSlideshow(scope = document) {
    $$('[data-slideshow]', scope).forEach((el) => {
      if (el._ss) el._ss.stop();
      const slides = $$('[data-slide]', el), dots = $$('[data-dot]', el);
      if (slides.length < 2) return;
      const speed = parseInt(el.dataset.speed, 10) || 6000;
      const auto = el.dataset.autoplay === 'true';
      el.style.setProperty('--hero-speed', speed + 'ms');
      let i = 0, timer = null;
      const go = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        dots.forEach((d, k) => { d.classList.remove('is-active'); if (k === i) { void d.offsetWidth; d.classList.add('is-active'); } });
      };
      const start = () => { if (!auto) return; stop(); timer = setInterval(() => go(i + 1), speed); };
      const stop = () => clearInterval(timer);
      dots.forEach((d) => d.addEventListener('click', () => { go(+d.dataset.dot); start(); }));
      let x0 = null;
      el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; });
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
      el._ss = { go, stop, start };
      start();
    });
  }

  /* ---------------- Tabs ---------------- */
  function initTabs(scope = document) {
    $$('[data-tabs]', scope).forEach((wrap) => {
      $$('[data-tab]', wrap).forEach((btn) => btn.addEventListener('click', () => {
        $$('[data-tab]', wrap).forEach(b => b.classList.toggle('is-active', b === btn));
        $$('[data-tab-panel]', wrap).forEach(p => { p.hidden = p.dataset.tabPanel !== btn.dataset.tab; });
        initReveal(wrap);
      }));
    });
  }

  /* ---------------- Cart ---------------- */
  const Cart = {
    sections() { const s = ['cart-drawer']; if ($('[data-cart-page]')) s.push(mainCartSectionId()); return s.filter(Boolean); },
    async add(formData) {
      formData.append('sections', this.sections().join(','));
      formData.append('sections_url', window.location.pathname);
      const res = await fetch(`${T.routes.cartAdd || root + 'cart/add'}.js`, { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      this.render(data.sections);
      await this.refreshCount();
      return data;
    },
    async change(key, quantity) {
      const res = await fetch(`${T.routes.cartChange || root + 'cart/change'}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: this.sections(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      this.render(data.sections); this.setCount(data.item_count);
      return data;
    },
    async note(value) {
      await fetch(`${T.routes.cartUpdate || root + 'cart/update'}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: value }) });
    },
    render(sections) {
      if (!sections) return;
      if (sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer-inner]'), cur = $('[data-cart-drawer-inner]');
        if (fresh && cur) cur.replaceWith(fresh);
      }
      const mid = mainCartSectionId();
      if (mid && sections[mid]) {
        const doc = new DOMParser().parseFromString(sections[mid], 'text/html');
        const fresh = doc.querySelector('[data-cart-page]'), cur = $('[data-cart-page]');
        if (fresh && cur) cur.replaceWith(fresh);
      }
    },
    async refreshCount() {
      try { const c = await fetch(`${root}cart.js`).then(r => r.json()); this.setCount(c.item_count); } catch (e) { /* ignore */ }
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = n; el.classList.toggle('is-empty', !n);
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      });
    }
  };
  function mainCartSectionId() {
    const s = $('[data-cart-page]')?.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  async function handleAdd(form, btn) {
    const fd = new FormData(form);
    btn?.classList.add('is-loading'); if (btn) btn.disabled = true;
    try {
      await Cart.add(fd);
      form.closest('.quick-pick')?.removeAttribute('open');
      if (T.cartType === 'drawer' && $('[data-drawer="cart"]')) Drawer.open('cart');
      else toast(T.strings.added);
    } catch (err) {
      const errEl = form.querySelector('[data-form-error]');
      if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } else toast(err.message);
    } finally {
      btn?.classList.remove('is-loading'); if (btn) btn.disabled = false;
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('[data-quick-add]')) {
      if (T.cartType !== 'drawer' && !$('[data-cart-page]')) return; // allow normal submit to cart page
      e.preventDefault(); handleAdd(form, form.querySelector('[type="submit"]'));
      return;
    }
    if (form.matches('.product-form')) {
      const submitter = e.submitter;
      if (submitter && submitter.hasAttribute('data-buy-now')) return; // native submit → checkout
      if (T.cartType !== 'drawer') return;
      e.preventDefault(); handleAdd(form, form.querySelector('[data-atc]'));
    }
  });

  // quantity + remove inside cart drawer / cart page
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-change]');
    const rm = e.target.closest('[data-line-remove]');
    const item = (step || rm)?.closest('.cart-item');
    if (!item) return;
    e.preventDefault();
    const input = $('[data-line-qty]', item);
    let q = rm ? 0 : Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyChange, 10));
    updateLine(item, q);
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-line-qty]')) { const item = e.target.closest('.cart-item'); updateLine(item, Math.max(0, parseInt(e.target.value, 10) || 0)); }
    if (e.target.matches('[data-cart-note]')) Cart.note(e.target.value);
  });
  async function updateLine(item, q) {
    item.classList.add(q === 0 ? 'is-removing' : 'is-updating');
    try { await Cart.change(item.dataset.key, q); }
    catch (err) { toast(err.message); item.classList.remove('is-removing', 'is-updating'); }
  }

  // close quick-pick when clicking outside
  document.addEventListener('click', (e) => {
    $$('.quick-pick[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------------- Product ---------------- */
  function initProduct(scope = document) {
    $$('[data-product-section]', scope).forEach((section) => {
      const jsonEl = $('[data-product-json]', section); if (!jsonEl) return;
      let data; try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      const picker = $('[data-variant-picker]', section);
      const idInput = $('[data-variant-id]', section);
      const atc = $('[data-atc]', section), atcLabel = $('[data-atc-label]', section), buyNow = $('[data-buy-now]', section);
      const priceWrap = $('[data-product-price]', section), stock = $('[data-stock]', section);
      const sticky = $('[data-sticky-atc]', section);
      const groups = picker ? $$('.variants__group', picker) : [];

      const selected = () => groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
      const findVariant = (opts) => data.variants.find(v => v.options.every((o, i) => o === opts[i]));

      function updateAvailability(opts) {
        groups.forEach((g, gi) => {
          $$('[data-option-value]', g).forEach((input) => {
            const test = opts.slice(); test[gi] = input.value;
            const ok = data.variants.some(v => v.available && v.options.every((o, i) => o === test[i]));
            const exists = data.variants.some(v => v.options.every((o, i) => o === test[i]));
            const label = input.nextElementSibling;
            label?.classList.toggle('is-unavailable', !ok);
            if (label && !exists) label.classList.add('is-unavailable');
          });
          const lab = $('[data-option-label]', g), c = $('input:checked', g);
          if (lab && c) lab.textContent = c.value;
        });
      }

      function updateUI(v) {
        if (!v) {
          if (atc) atc.disabled = true; if (atcLabel) atcLabel.textContent = T.strings.unavailable; if (buyNow) buyNow.disabled = true;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (atc) atc.disabled = !v.available;
        if (buyNow) buyNow.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
        if (priceWrap) {
          const sale = v.compare_at_price > v.price;
          const pct = sale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
          priceWrap.innerHTML = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${v.price_formatted}</span>${sale ? `<s class="price__compare">${v.compare_formatted}</s><span class="price__save">-${pct}%</span>` : ''}</div>`;
        }
        if (stock) {
          const th = parseInt(stock.dataset.threshold, 10) || 5;
          const q = v.inventory_quantity;
          if (!v.available) stock.innerHTML = '';
          else if (q !== null && q > 0 && q <= th) stock.innerHTML = `<span class="stock__dot stock__dot--low"></span> ${stockLowText(q)}`;
          else stock.innerHTML = `<span class="stock__dot"></span> ${stockInText()}`;
        }
        if (sticky) {
          const sv = $('[data-sticky-variant]', sticky);
          if (sv) sv.innerHTML = `${v.title !== 'Default Title' ? v.title + ' · ' : ''}<span data-sticky-price>${v.price_formatted}</span>`;
          const sb = $('[data-sticky-btn]', sticky); if (sb) sb.disabled = !v.available;
        }
        if (v.featured_media_id) gallery.goToMedia(v.featured_media_id);
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      function stockLowText(q) { return (T.strings.lowStock || 'Hurry — only [count] left!').replace('[count]', q); }
      function stockInText() { return T.strings.inStock || 'In stock, ready to ship'; }

      if (picker) {
        picker.addEventListener('change', () => {
          picker.classList.remove('needs-selection');
          const opts = selected();
          updateAvailability(opts);
          updateUI(findVariant(opts));
        });
        updateAvailability(selected());
      }


      // quantity steppers
      $$('[data-qty-step]', section).forEach((b) => b.addEventListener('click', () => {
        const input = b.parentElement.querySelector('input'); input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
      }));

      // gallery
      const gallery = initGallery(section);

      // sticky add to cart
      if (sticky && atc) {
        const io = new IntersectionObserver(([en]) => {
          const show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
          document.body.classList.toggle('has-sticky-atc', show);
        });
        io.observe(atc);
        $('[data-sticky-btn]', sticky)?.addEventListener('click', () => {
          const form = atc.form;
          if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
        });
      }

      // copy link
      $$('[data-copy-link]', section).forEach(b => b.addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(b.dataset.copyLink); toast('Link copied'); } catch (e) { /* ignore */ }
      }));

      // recently viewed
      const rv = store.get('ia_recent', []).filter(h => h !== data.handle);
      rv.unshift(data.handle); store.set('ia_recent', rv.slice(0, 12));
    });
  }

  function initGallery(section) {
    const wrap = $('[data-gallery]', section);
    const api = { goToMedia() {} };
    if (!wrap) return api;
    const track = $('[data-gallery-track]', wrap);
    const slides = $$('.gallery__slide', track), thumbs = $$('[data-thumb]', wrap), dots = $$('.gallery__dot', wrap);
    const setActive = (i) => {
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const goTo = (i) => { const s = slides[i]; if (!s) return; track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); setActive(i); };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(+t.dataset.thumb)));
    track.addEventListener('scroll', debounce(() => { const i = Math.round(track.scrollLeft / track.clientWidth); setActive(i); }, 60), { passive: true });
    // hover zoom (desktop)
    $$('[data-zoom]', wrap).forEach((z) => {
      if (window.matchMedia('(hover: none)').matches) return;
      z.addEventListener('click', () => z.classList.toggle('is-zoomed'));
      z.addEventListener('mousemove', (e) => { const r = z.getBoundingClientRect(); z.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); z.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
      z.addEventListener('mouseleave', () => z.classList.remove('is-zoomed'));
    });
    api.goToMedia = (id) => { const i = slides.findIndex(s => s.dataset.mediaId == id); if (i > -1) goTo(i); };
    const initial = new URL(window.location.href).searchParams.get('variant');
    if (initial) {
      try { const d = JSON.parse($('[data-product-json]', section).textContent); const v = d.variants.find(x => x.id == initial); if (v && v.featured_media_id) setTimeout(() => api.goToMedia(v.featured_media_id), 50); } catch (e) { /* ignore */ }
    }
    return api;
  }

  /* ---------------- Recommendations ---------------- */
  function initRecommendations(scope = document) {
    $$('[data-recommendations]', scope).forEach(async (el) => {
      if (!el.dataset.url || el.dataset.loaded) return;
      el.dataset.loaded = '1';
      try {
        const html = await fetch(el.dataset.url).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); }
      } catch (e) { /* ignore */ }
    });
  }

  /* ---------------- Recently viewed ---------------- */
  function initRecentlyViewed(scope = document) {
    $$('[data-recently-viewed]', scope).forEach(async (el) => {
      const grid = $('[data-recently-viewed-grid]', el);
      const limit = parseInt(el.dataset.limit, 10) || 4;
      const handles = store.get('ia_recent', []).filter(h => h && h !== el.dataset.current).slice(0, limit);
      if (!handles.length || !grid) return;
      const cards = await Promise.all(handles.map(h => fetch(`${root}products/${h}?view=card`).then(r => (r.ok ? r.text() : '')).catch(() => '')));
      const html = cards.filter(c => c.includes('card')).join('');
      if (!html) return;
      grid.innerHTML = html; el.hidden = false; initReveal(el);
    });
  }

  /* ---------------- Collection filters ---------------- */
  function initCollection(scope = document) {
    $$('[data-collection-section]', scope).forEach((section) => {
      const sid = section.dataset.sectionId;
      const results = () => $('[data-results]', section);
      const render = async (url, push = true) => {
        results()?.classList.add('is-loading');
        const u = new URL(url, window.location.origin); u.searchParams.set('section_id', sid);
        try {
          const html = await fetch(u.toString()).then(r => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-results]', '[data-facets-container]', '[data-products-count]'].forEach((sel) => {
            const fresh = doc.querySelector(sel), cur = $(sel, section);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
          if (push) { const clean = new URL(url, window.location.origin); clean.searchParams.delete('section_id'); history.pushState({ facets: true }, '', clean.toString()); }
          initReveal(section);
        } catch (e) { window.location.href = url; }
        results()?.classList.remove('is-loading');
      };
      const formUrl = () => {
        const form = $('[data-facets-form]', section);
        const params = new URLSearchParams(form ? new FormData(form) : undefined);
        const sort = $('[data-sort-select]', section)?.value; if (sort) params.set('sort_by', sort);
        for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
        return `${window.location.pathname}?${params.toString()}`;
      };
      const debounced = debounce(() => render(formUrl()), 450);
      section.addEventListener('change', (e) => {
        if (e.target.closest('[data-facets-form]')) { e.target.type === 'number' ? debounced() : render(formUrl()); }
        if (e.target.matches('[data-sort-select]')) render(formUrl());
      });
      section.addEventListener('input', (e) => { if (e.target.closest('[data-facets-form]') && e.target.type === 'number') debounced(); });
      section.addEventListener('submit', (e) => { if (e.target.matches('[data-facets-form]')) { e.preventDefault(); render(formUrl()); } });
      section.addEventListener('click', async (e) => {
        const link = e.target.closest('[data-facet-link]');
        if (link && link.href) { e.preventDefault(); render(link.href); return; }
        const more = e.target.closest('[data-load-more]');
        if (more) {
          e.preventDefault(); more.classList.add('is-loading'); more.textContent = '…';
          const u = new URL(more.href, window.location.origin); u.searchParams.set('section_id', sid);
          try {
            const html = await fetch(u.toString()).then(r => r.text());
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const grid = $('[data-product-grid]', section), fresh = doc.querySelector('[data-product-grid]');
            if (grid && fresh) { $$('.card', fresh).forEach((c) => grid.appendChild(c)); }
            const wrap = $('[data-load-more-wrap]', section), freshWrap = doc.querySelector('[data-load-more-wrap]');
            if (wrap) { if (freshWrap) wrap.innerHTML = freshWrap.innerHTML; else wrap.remove(); }
            initReveal(section);
          } catch (err) { window.location.href = more.href; }
        }
      });
    });
  }
  window.addEventListener('popstate', (e) => { if (e.state && e.state.facets) window.location.reload(); });

  /* ---------------- Countdown ---------------- */
  function initCountdown(scope = document) {
    $$('[data-countdown]', scope).forEach((el) => {
      if (el._cd) clearInterval(el._cd);
      const end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) return;
      const parts = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
      const pad = n => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        if (diff === 0) { clearInterval(el._cd); if (el.dataset.hideOnEnd === 'true' && !window.Shopify?.designMode) el.closest('.shopify-section')?.setAttribute('hidden', ''); }
        const v = { d: Math.floor(diff / 864e5), h: Math.floor(diff / 36e5) % 24, m: Math.floor(diff / 6e4) % 60, s: Math.floor(diff / 1e3) % 60 };
        Object.keys(parts).forEach((k) => { const t = pad(v[k]); if (parts[k] && parts[k].textContent !== t) { parts[k].textContent = t; parts[k].classList.remove('tick'); void parts[k].offsetWidth; parts[k].classList.add('tick'); } });
      };
      tick(); el._cd = setInterval(tick, 1000);
    });
  }

  /* ---------------- Size calculator ---------------- */
  function initSizeCalc(scope = document) {
    $$('[data-size-calc]', scope).forEach((el) => {
      const ub = $('[data-underbust]', el), bust = $('[data-bust]', el);
      const out = $('[data-size-result]', el), outBtn = $('[data-size-result-btn]', el), shop = $('[data-size-shop]', el);
      const cups = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'G', 'H'];
      const calc = () => {
        const u = parseFloat(ub.value), b = parseFloat(bust.value);
        if (!u || !b || b <= u) { out.textContent = '—'; outBtn.textContent = ''; return; }
        let band = Math.round(u); if (band % 2 !== 0) band += 1;
        const diff = Math.round(b - band);
        const cup = cups[Math.min(Math.max(diff, 0), cups.length - 1)];
        const size = band + cup;
        if (out.textContent !== size) { out.textContent = size; out.classList.add('pop'); setTimeout(() => out.classList.remove('pop'), 250); }
        outBtn.textContent = size;
        const base = el.dataset.shopUrl || `${root}collections/all`;
        shop.href = `${base}?q=${encodeURIComponent(size)}&filter.v.option.size=${encodeURIComponent(size)}`;
      };
      ub.addEventListener('input', calc); bust.addEventListener('input', calc); calc();
    });
  }

  /* ---------------- Newsletter popup ---------------- */
  function closePopup() {
    const p = $('[data-popup]'); if (!p || p.hidden) return;
    p.hidden = true; document.body.classList.remove('is-locked');
    store.set('ia_popup', Date.now());
  }
  function initPopup() {
    const p = $('[data-popup]'); if (!p) return;
    const posted = p.querySelector('.form-success');
    $$('[data-popup-close]', p).forEach(b => b.addEventListener('click', closePopup));
    p.addEventListener('click', (e) => { if (e.target === p) closePopup(); });
    if (posted) { p.hidden = false; return; }
    if (window.Shopify && window.Shopify.designMode) return;
    const last = store.get('ia_popup', 0), days = parseInt(p.dataset.days, 10) || 7;
    if (Date.now() - last < days * 864e5) return;
    setTimeout(() => { if (!Drawer.current) { p.hidden = false; } }, parseInt(p.dataset.delay, 10) || 8000);
  }

  /* ---------------- Misc ---------------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-toggle-recover]');
    if (a) { e.preventDefault(); $('#recover')?.removeAttribute('hidden'); $('#LoginBox')?.setAttribute('hidden', ''); }
  });

  function initAll(scope = document) {
    initReveal(scope); initSlideshow(scope); initTabs(scope); initProduct(scope);
    initRecommendations(scope); initRecentlyViewed(scope); initCollection(scope);
    initCountdown(scope); initSizeCalc(scope);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader(); initAll(); initPopup();
    if (location.hash === '#recover') { $('#recover')?.removeAttribute('hidden'); $('#LoginBox')?.setAttribute('hidden', ''); }
  });

  /* ---------------- Theme editor ---------------- */
  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
    if (e.target.querySelector('[data-header]')) initHeader();
    if (e.target.querySelector('[data-drawer="cart"]')) Drawer.open('cart');
    if (e.target.querySelector('[data-popup]')) { const p = $('[data-popup]'); if (p) p.hidden = false; }
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('[data-drawer="cart"]')) Drawer.open('cart');
    if (e.target.querySelector('[data-popup]')) { const p = $('[data-popup]'); if (p) p.hidden = false; }
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('[data-drawer="cart"]')) Drawer.close();
    if (e.target.querySelector('[data-popup]')) { const p = $('[data-popup]'); if (p) p.hidden = true; }
  });
  document.addEventListener('shopify:block:select', (e) => {
    const ss = e.target.closest('[data-slideshow]');
    if (ss && ss._ss) { const i = Array.from(ss.querySelectorAll('[data-slide]')).indexOf(e.target); ss._ss.stop(); ss._ss.go(i); }
    e.target.classList?.add('is-visible');
  });
  document.addEventListener('shopify:block:deselect', (e) => { const ss = e.target.closest('[data-slideshow]'); if (ss && ss._ss) ss._ss.start(); });
})();
